<template>
  <b-modal
    id="modal-form-container"
    ref="modal-form-container"
    size="lg"
    centered
    scrollable
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    :title="modalTitle"
  >
    <MenuSection
      v-if="modalType == 'menu'"
      :typeSelected="typeSelected"
      @update:typeSelected="(e) => (typeSelected = e)"
    />

    <FormSection
      v-if="modalType == 'form'"
      ref="form-section-ref"
      :typeSelected="typeSelected"
      :isLoading="isLoading"
      :formType="formType"
    />

    <template #modal-footer="{ cancel }">
      <div class="d-flex gap-2">
        <McButton
          variant="secondary"
          icon="icon-outline_close"
          :text="$t('global.action.cancel')"
          :disabled="isLoading"
          @click="() => handleCancel(cancel)"
        />
        <McButton
          v-if="modalType == 'menu'"
          variant="primary"
          :text="$t('global.next')"
          iconPosition="right"
          icon="icon-outline_arrow-right"
          :disabled="!typeSelected.key"
          @click="modalType = 'form'"
        />
        <template v-if="modalType == 'form'">
          <McButton
            v-if="formType == 'create'"
            variant="secondary"
            :text="$t('global.prev')"
            icon="icon-outline_arrow-left"
            :disabled="isLoading"
            @click="modalType = 'menu'"
          />
          <McButton
            variant="primary"
            :text="$t('global.save')"
            icon="icon-outline_save"
            :disabled="isLoading"
            @click="handleSubmit"
          />
        </template>
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import MenuSection from './ModalTypeCard/MenuSection'
import FormSection from './ModalTypeCard/FormSection'

import * as CustomField from '@/services/rest-api/lib/setting/quick-assignment/custom-field'

export default {
  components: {
    McButton,
    MenuSection,
    FormSection,
  },
  inject: ['typeItems'],
  props: {
    formType: {
      type: String,
      default: 'create',
    },
    selectedItem: {
      type: Object,
      default: () => {},
    },
    customSuccessMsg: {
      type: String,
      default: 'Berhasil disimpan.',
    },
  },
  emits: ['reloadList'],
  data() {
    return {
      isLoading: false,
      typeSelected: {
        key: '',
        title: '',
      },
      modalType: 'menu',
    }
  },
  computed: {
    modalTitle() {
      if (this.modalType == 'form') {
        return this.formType == 'update' ? 'Ubah Kolom Kustom' : 'Tambah Kolom Kustom Baru'
      }

      return this.$t('customField.title.chooseFieldType')
    },
  },
  watch: {
    selectedItem(newValue) {
      if (this.formType != 'update') return

      this.typeSelected = this.typeItems.find((item) => item.key == newValue.type)
    },
  },
  methods: {
    resetTypeSelected() {
      this.typeSelected = {
        key: '',
        title: '',
      }
    },
    showModal(modalType = 'menu') {
      this.modalType = modalType
      this.$bvModal.show('modal-form-container')
    },
    hideModal() {
      this.resetTypeSelected()

      this.$bvModal.hide('modal-form-container')
    },
    handleCancel(cancel) {
      this.resetTypeSelected()
      cancel()
    },
    async submitCreate(formValues) {
      const data = { 
        ...formValues,
        entity: 'FLEET_TASK_INSTANT'
      }
      
      const res = await CustomField.store(data)
      return res
    },
    async submitUpdate(formValues) {
      const res = await CustomField.update(this.selectedItem.id, formValues)
      return res
    },
    async handleSubmit() {
      const formSectionRef = this.$refs['form-section-ref']
      const formValues = formSectionRef.GetFormValues()
      if (formValues == false) return

      this.isLoading = true

      let res

      if (this.formType == 'create') {
        res = await this.submitCreate(formValues)
      } else if (this.formType == 'update') {
        res = await this.submitUpdate(formValues)
      }

      if (res.errors_v2) {
        this.isLoading = false
        formSectionRef.SetErrorsV2(res.errors_v2)
        return
      }

      this.$mcToast.success(this.customSuccessMsg)
      this.isLoading = false

      this.hideModal()
      this.$emit('reloadList')
    },
  },
}
</script>

<style lang="scss" scoped>
.clear-search-btn {
  border: none;
  background-color: transparent;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    color: $mep-color-text-200;
  }
}
</style>
